


































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { User, CvLink, QuestionMark } from './icons';
const guidedWalkthroughs = 'Guided Walkthroughs';

interface IUserMenuLink {
    caption: string;
    path: string;
    action?: (e: Event) => void;
    target: string;
}

const userMenuBase: IUserMenuLink[] = [
    { caption: 'Change Password', path: `/my/change-password?returnUrl=${encodeURIComponent(document?.location?.href||'')}`, target: '_self'},
    { caption: 'Reset Multi-factor Authentication', path: '/my/login/security-questions', target: '_self' },
    { caption: 'Manage Security Questions', path: '/my/login/security-questions/manage', target: '_self' },
    { caption: 'Manage Auditor Representatives', path: '/auditor', target: '_self' },
    { caption: 'Change Business', path: '/my/business-summary?RemeberTableState=False', target: '_self' },
    { caption: 'Privacy Policy', path: 'https://www.class.com.au/privacy', target: '_blank' },
    // { caption: 'Change Business', path: '/' },
    { caption: 'End User License Agreement', path: 'https://www.class.com.au/eula', target: '_blank' },
    { caption: 'About Us', path: 'https://www.class.com.au/about-us', target: '_blank' },
];

function makeHelpMenu(): IUserMenuLink[] {
    return [
        { caption: 'Class Help Center', path: 'https://support.class.com.au/hc/en-au', target: '_blank' },
        { caption: 'Classmate - Chatbot', path: 'javascript:openSupportRequest()', target: '_self' },
        { caption: 'Training & Webinars', path: 'https://training.class.com.au/', target: '_blank' },
        { caption: guidedWalkthroughs, path: 'javascript:WalkMePlayerAPI.toggleMenu()', target: '_self' },
        { caption: "What's New", path: 'https://support.class.com.au/hc/en-au/sections/360000247996-What-s-New', target: '_blank' },
        { caption: 'About Class', path: 'https://www.class.com.au/about/what-we-do/', target: '_blank' },
    ];
}

function head(array: any[]): any[] {
    // return array.slice(0, 1)
    return [...array][0];
}

function tail(array: any[]): any[] {
    return array.slice(1);
}

function capitalize(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

@Component({
    components: {
        User,
        CvLink,
        QuestionMark,
    },
})
export default class UserMenu extends Vue {
    @Inject({ default: null }) public menuState: {
        activeIndex: number | undefined;
        menuIsOpen: boolean | undefined;
        userIsOpen: boolean | undefined;
        helpIsOpen: boolean | undefined;
    };

    @Prop({ required: true }) public username: string;
    @Prop({ default: '' }) public clientViewUrl: string;


    public helpMenu: IUserMenuLink[]

    public get userMenu(): IUserMenuLink[] {
        return userMenuBase.concat([
            { caption: `Log out ${this.username}`, path: '/my/logout', target: '_self' },
        ]);
    }

    public closeMenu() {
        this.menuState.userIsOpen = false;
        this.menuState.helpIsOpen = false;
    }

    public onClick(label: string) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (label === guidedWalkthroughs && !(<any>window)?.WalkMePlayerAPI) {
            return;
        }
        this.closeMenu();
    }

    public toggleMenu(name: string): void {
        this.helpMenu = makeHelpMenu();
        this.menuState.menuIsOpen = false;
        switch (name) {
            case 'user':
                this.menuState.userIsOpen = !this.menuState.userIsOpen;
                this.menuState.helpIsOpen = false;
                break;
            case 'help':
                this.menuState.userIsOpen = false;
                this.menuState.helpIsOpen = !this.menuState.helpIsOpen;
                break;
            default:
                this.menuState.userIsOpen = false;
                this.menuState.helpIsOpen = false;
                break;
        }
    }

    mounted() {
        this.helpMenu = makeHelpMenu();
    }
}
